import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { bubEvents } from 'javascripts/shared/events/bub_events';
import { graphQLQueries } from 'javascripts/shared/graphql/queries';

import { CarouselWithGraphQL } from 'javascripts/components/carousel_with_graphql';
import { CoverImage } from 'javascripts/components/cover_image';

const RECENTLY_VIEWED_AUDIOBOOKS_MAX = 7;

export function RecentlyViewedCarousel(props) {
  const omitAudiobookIds = useMemo(() => props.omitAudiobookIds, props.omitAudiobookIds);

  function renderRecentlyViewedResponse(graphQLResponse, trackingCategory) {
    function trackRecentlyViewedCoverClick(bookId, index) {
      bubEvents.track(trackingCategory, 'Clicked audiobook cover', {
        label: 'Audiobook id',
        value: bookId,
        carousel_position: bubEvents.trackingIndex(index),
        ...props.trackingProperties,
      });
    }

    if (!_.isEmpty(graphQLResponse.errors)) {
      throw graphQLResponse.errors[0];
    }

    if (graphQLResponse.loading || _.isEmpty(graphQLResponse.currentUserRecentAudiobooks)) {
      return [];
    }

    return graphQLResponse.currentUserRecentAudiobooks.map((book, index) => (
      <div key={`${trackingCategory} ${book.id}`}>
        <CoverImage
          bookAuthor={book.displayAuthors}
          bookTitle={book.displayTitle}
          coverUrl={book.coverUrl}
          linkUrl={book.url}
          onClick={() => trackRecentlyViewedCoverClick(book.id, index)}
          openNewTab
          bannerType={book.currentProduct?.bannerType}
          size='medium'
        />
      </div>
    ));
  }

  return (
    <CarouselWithGraphQL
      query={graphQLQueries.recentlyViewedAudiobooks}
      queryParams={{
        omitAudiobookIds,
        pageSize: RECENTLY_VIEWED_AUDIOBOOKS_MAX,
      }}
      renderResponseFunction={renderRecentlyViewedResponse}
      slideSize={7}
      title='Recently Viewed'
      trackingCategory='Recently Viewed Carousel'
      hideArrows
      hideEmptyCarousel
    />
  );
}

RecentlyViewedCarousel.propTypes = {
  omitAudiobookIds: PropTypes.arrayOf(PropTypes.string),
  trackingProperties: PropTypes.object,
};

RecentlyViewedCarousel.defaultProps = {
  omitAudiobookIds: [],
};
